export const createStyles = (theme?: any, isDesktop?: boolean) => {
  const isDark = theme?.palette?.mode === 'dark';
  const primary = theme?.palette?.primary?.main ?? '#5B35A5';
  const titleColor = isDark ? '#FFFFFF' : '#000000DE !important';
  const iconBackground = isDark ? '#D0BCFA' : primary;
  const iconColor = isDark ? '#121212' : '#FFFFFF';
  const borderColor = isDark ? '#F8F7F929' : '#231F2929';
  const tooltipColor = isDark ? '#D7D2DF' : '#5D536C';
  const tooltipTextColor = isDark ? '#230254' : '#FFFFFF';

  return {
    sidebarWrapper: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      fontFamily: theme.typography.fontFamily,
    },
    buttonWrapper: {
      px: { xs: '16px', md: '12px' },
      pt: { xs: '16px', md: '12px' },
      marginLeft: '-8px',
    },
    backButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    sidebarContent: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      px: { xs: '12px', md: '12px' },
    },
    listWrapper: {
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
    },
    searchWrapper: {
      mt: '16px',
    },
    clearSearchButton: {
      position: 'absolute',
      right: 8,
      top: '50%',
      transform: 'translateY(-50%)',
      cursor: 'pointer',
      border: 'none',
      background: 'none',
      color: 'text.secondary',
      padding: 0,
      display: 'flex',
      alignItems: 'center',
    },
    headerWrapper: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      gap: '11px',
      minWidth: 0,
      my: '16px',
    },
    headerIcon: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: iconBackground,
      flexShrink: 0,
      color: iconColor,
    },
    title: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: 600,
      fontStyle: 'normal',
      fontSize: '1.25rem',
      lineHeight: '160%',
      letterSpacing: '0px',
      flexShrink: 1,
      minWidth: 0,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: titleColor,
    },
    spaceName: {
      display: { xs: '-webkit-box', md: 'none' },
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: '500',
      fontSize: '1.25rem',
      lineHeight: '160%',
      letterSpacing: '0.15px',
      color: theme.palette.text.secondary,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      mt: '0px',
      mb: '12px',
    },
    createButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      height: '42px',
      width: '100%',
    },
    mobileCreateButton: {
      display: { xs: 'flex', md: 'none' },
      flexShrink: 0,
    },
    assignmentToolsWrapper: {
      p: '0.5rem',
      border: `1px solid ${borderColor}`,
      mt: '1rem',
      borderRadius: '0.5rem',
    },
    common: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    avatarStyle: {
      height: '32px',
      width: '32px',
      cursor: 'default',
    },
    newTabIcon: {
      height: '20px',
      width: '20px',
    },
    toolTitle: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: 500,
      fontSize: '0.875rem',
    },
    tooltipStyles: {
      arrow: {
        sx: {
          left: '45% !important',
          transform: 'translateX(-50%) !important',
          color: tooltipColor,
        },
      },
      tooltip: {
        sx: {
          marginLeft: '25px',
          maxWidth: '230px',
          backgroundColor: tooltipColor,
          color: tooltipTextColor,
        },
      },
    },
    modalContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflowX: 'hidden',
    },
    modalHeader: {
      p: 0,
      pb: 1,
      mr: -1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexShrink: 0,
    },
    modalContent: {
      p: 0,
      my: 1,
    },
    modalCardTitle: {
      color: theme.palette.primary.main,
      fontSize: '1rem',
      fontWeight: 'bold',
    },
    modalCardDescription: {
      color: theme.palette.text.secondary,
      fontSize: '.875rem',
      lineHeight: '180%',
      pt: 1,
      pb: 2,
    },
    modalFooter: {
      p: 0,
      display: 'flex',
      justifyContent: 'end',
      '& button': {
        px: 3,
        py: 1,
        textTransform: 'initial',
      },
    },
    noResultsCard: {
      width: '100%',
      height: { xs: 'auto' },
      gap: '4px',
      borderRadius: theme?.shape?.borderRadius ?? 2,
      bgcolor: isDark
        ? isDesktop
          ? '#231F29'
          : '#3A3444'
        : isDesktop
        ? '#F8F7F9'
        : '#FFFFFF',
      pt: { xs: '12px', sm: '12px', md: '16px' },
      px: { xs: '16px', sm: '16px', md: '16px' },
      pb: { xs: '12px', sm: '12px', md: '16px' },
      opacity: 1,
      boxSizing: 'border-box',
    },
    noResultsCardTitle: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      fontSize: '1rem',
      lineHeight: '175%',
      letterSpacing: '0.15px',
      color: 'text.primary',
      textAlign: 'center',
      mt: '-0.25rem',
    },
    noResultsCardDescription: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      fontSize: '0.875rem',
      lineHeight: '143%',
      letterSpacing: '0.17px',
      textAlign: 'center',
      color: 'text.secondary',
      whiteSpace: 'pre-line',
    },
  };
};
